import Base from './Base';
import Colors from '../../Components/Widgets/Colors.svelte';
import Gallery from '../../Stores/Gallery';
import Helper from '../Helper';
import Option from '../../Components/Widgets/Option.svelte';
import Product from '../../Stores/Product';

export default class Color extends Base {
	build(list) {
		const group = this.product().group;
		const property = this.product().property;
		const selected = property.selected || {};

		list = this.ral(list, group, selected);
		const options = this.options(selected, group);
		const config = {
			options,
			on_click: async (item, option) => {
				try {
					const data = this.product().property.selected.data;
					if (this.$options && data && data.finish)
						if (data.finish > this.$options.length)
							data.finish = 1;

					this.product().property.selected = item;
					this.product().property.selected.data = data;
					this.price();
					this.update(true);

					const texture = property.render_texture;
					const image = Helper.image(option.image);

					if (!Helper.is(this.product().config.renderer)) this.product().config.renderer = {};
					this.product().config.renderer[texture] = image;
					window.renderer.pauseRotation(true);
					await window.renderer.texture(texture, image);
					Gallery.render();
					window.renderer.pauseRotation(false);
				}
				catch (exception)
					{ console.error(exception); }
			}
		};

		const component = {component: Colors, config};
		list.push(component);
		return list;
	}

	ral(list, group, selected) {
		const options = [];
		if (group.finish_type_1)
			options.push({value: 1, label: group.finish_type_1});

		if (group.finish_type_2)
			options.push({value: 2, label: group.finish_type_2});

		if (options.length) {
			this.$options = options;

			const title_combined = `${group.finish_type_1} of ${group.finish_type_2}?`;
			const title = group.finish_type_2 ? title_combined : 'Afwerking'

			const description_combined = `De ${group.name} kan in ${group.finish_type_1} of ${group.finish_type_2} afgewerkt worden. Selecteer hier welke optie uw voorkeur heeft.`;
			const description_single = `De ${group.name} zal in ${group.finish_type_1} afgewerkt worden.`;
			let description = group.finish_type_2 ? description_combined : description_single;

			if (!selected.data)
				selected.data = {finish: 1};

			const extra = this.product().property.selected;
			if (Helper.is(extra.price))
				description += `<br/>De meerprijs van <strong>${extra.label}</strong> is <strong>${Product.price(extra.price)}</strong>`

			list.push({
				component: Option,
				config: {
					options, title, description,
					checked: true,
					compact: true,
					value: selected.data.finish,
					on_change: item => {
						selected.data.finish = item.value;
						this.price();
						this.update(true);
					}
				}
			});
		}

		return list;
	}

	options(selected, group) {
		const options = [];
		if (Array.isArray(group.values))
			for (let value of group.values) {
				const option = {
					value: value.id,
					label: value.value,
					description: value.description || '',
					price: value.price || Product.variationPercentage(value.percentage) || Product.variationPercentage(group.percentage),
					upgrade: group.upgrade_id,
					active: value.id === selected.value,
					image: this.validImage(value.image)
				};

				options.push(option);
			}

		return options;
	}

	price() {
		let label = this.product().property.selected.label;
		if (label) {
			const group = this.product().group;
			const variation = this.product().variation;
			const data = this.product().property.selected.data;

			let price = data?.price || 0;
			if (data?.finish)
				for (let item of variation.additional_prices)
					if (item.shop_upgrade.id === group.upgrade_id) {
						const cost = item.shop_upgrade[`finish_${data.finish}`];
						price += parseFloat(cost);
						break;
					}

			if (!isNaN(price) && price) {
				label = label.replace(/\s\-\s[^\-]+$/, '');
				if (data?.finish)
					label += ` - ${group[`finish_type_${data.finish}`]}`;

				this.product().property.selected.label = label;
				this.product().property.selected.price = price;
			}
		}
	}
}